import GenericDialog from '@gef-ui/material/components/Dialog/GenericDialog';
import PropTypes from 'prop-types';
import React from 'react';
import { errorPropType } from '../../constants';
import { useDefaultComponentValue } from '../../utils';
import SimpleError from '../SimpleError';
const COMPONENT_NAME = 'SimpleModalError';
const SimpleModalError = (inProps)=>{
    const props = useDefaultComponentValue({
        name: COMPONENT_NAME,
        inProps
    });
    const { actionButton, onRefreshError, error, onCloseModal, showReport: showReportProp, ...other } = props;
    if (!error) {
        return null;
    }
    const ContentComponent = error?.components?.Content ? error.components.Content : SimpleError;
    const dialogProps = error?.components?.dialogProps ? error?.components?.dialogProps : {};
    return /*#__PURE__*/ React.createElement(GenericDialog, {
        withCross: error.unclosable ? undefined : !!onCloseModal,
        fullWidth: true,
        maxWidth: "md",
        onExit: error.unclosable ? undefined : onCloseModal,
        DialogContentProps: {
            sx: {
                px: 3,
                pb: 6,
                pt: error.unclosable ? 7 : undefined
            }
        },
        CrossButtonProps: {
            id: 'close-error-cross'
        },
        content: /*#__PURE__*/ React.createElement(ContentComponent, {
            error: error,
            showReport: showReportProp
        }),
        ...other,
        ...dialogProps
    });
};
SimpleModalError.propTypes = {
    error: errorPropType,
    onCloseModal: PropTypes.func,
    showReport: PropTypes.bool
};
export default SimpleModalError;
